const utils = require('../../../lib/utils')

module.exports = {
    model: {
        entities: {},
        config: {
            // fields: {
            //     toggle: {
            //         grantDirtyValues: { // prevent zero from being a valid dirty value
            //             1: true,
            //         },
            //     },
            // },
            separatedFieldCodes: {
                flag: 'flag', // where to take the boolean flag value from
                ts: 'ts', // where to take the timestamp for the ts-label from
                entityID: 'entityID', // where to take the entityID for the entity-label from
            },
            labelKeys: {
                toggle: {
                    positive: 'dataValues.boolean.1',
                    negative: 'dataValues.boolean.0',
                },
                ts: {
                    set: '',
                    unset: '',
                },
                entity: {
                    set: '',
                    unset: '',
                },
            },
            symbolsByToggleValue: {
                // 0: 'fi fi-exclamation-triangle',
                // 1: 'fi fi-check'
            }
        },
        labels: {
            toggle: '',
            ts: '',
            entity: '',
        },
        symbol: '',
        toggle: {
            fieldCode: 'flag',
            options: [
                {
                    value: 0,
                    // nameKey: 'dataValues.boolean.0', // set via model.config.labelKeys.toggle.negative
                },
                {
                    value: 1,
                    // nameKey: 'dataValues.boolean.1', // set via model.config.labelKeys.toggle.positive
                }
            ],
            value: 0,
        }
    },

    methods: {
        prepare: function () {
            // this.initRunTime()
            this.model.entities = this.model.entities || {}
            const options = (this.model['resource-picker-data'] || {}).options || []

            // init entities
            let o, entity, entityID, attributes
            for (o in options) {
                entity = (options[o] || {}).resource || {}
                attributes = entity.attributes || {}
                entityID = attributes[entity.primaryKey]
                this.model.entities[entityID] = attributes
            }

            this.model.entity = this.model.entities[(this.model.dataJSON || {}).entityID] || {}
            this.sanitizeLabels()
        },

        sanitizeLabels(){
            const fieldConfig   = this.model.config || {}
            const entity        = this.model.entity || {}
            const ts            = (this.model.dataJSON || {}).ts
            const entityID      = (this.model.dataJSON || {}).entityID
            const toggle        = this.model.toggle || {}

            const labels = this.model.labels = this.model.labels || {}
            const labelKeys = fieldConfig.labelKeys || {}
            labelKeys.toggle = labelKeys.toggle || {}
            labelKeys.ts = labelKeys.ts || {}
            labelKeys.entity = labelKeys.entity || {}

            if(ts && labelKeys.ts.set)          labels.ts = storage.__(labelKeys.ts.set, { ts: utils.moment(ts).format('DD.MM.YYYY HH:mm') });
            else if(!ts && labelKeys.ts.unset)  labels.ts = storage.__(labelKeys.ts.unset);

            if(entityID && labelKeys.entity.set)            labels.entity = storage.__(labelKeys.entity.set, { ...entity });
            else if(!entityID && labelKeys.entity.unset)    labels.entity = storage.__(labelKeys.entity.unset);

            // find value name
            if((this.model.dataJSON || {}).flag){
                toggle.value    = 1
                labels.toggle   = storage.__(labelKeys.toggle.positive)
            } else {
                toggle.value    = 0
                labels.toggle   = storage.__(labelKeys.toggle.negative)
            }
            this.model.symbol = (fieldConfig.symbolsByToggleValue || {})[toggle.value] || ''

            // set value name
            for(const o in toggle.options || []){
                const option = toggle.options[o] || {}
                option.name = labels.toggle
            }
        },

        change(value){
            let valueChanged = false;
            if(value !== undefined){
                if(!value) value = null;

                valueChanged = this.model.dataJSON.flag !== value;
                this.model.dataJSON.flag = value;
            }

            if(valueChanged){
                if(this.model.dataJSON.flag !== undefined){
                    this.triggerClosest('onChildChanged', {
                        fieldCode:  this.model.fieldCode,
                        value: {
                            flag:       this.model.dataJSON.flag,
                            ts:         this.model.dataJSON.ts,
                            entityID:   this.model.dataJSON.entityID,
                        }
                    });
                }
            }
        },
    },

    hooks: {
        onChildChanged: function($element, options){
            this.change(options.value)
        },
    },
}